import moment from "moment";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import * as actions from "../../actions/action-master";
import Circle from "../../assets/images/new-images/add.png";
import deleteIcon from "../../assets/images/new-images/delete.png";
import edit from "../../assets/images/new-images/edit.png";
import sortIcon from "../../assets/images/new-images/sortIcon.svg";
import AddNotificationType from "./AddNotificationType";
import DeleteNotificationType from "./DeleteNotificationType";
import { createNotificationType } from "../../actions/action-master";
import ActivateNotificationType from "./ActivateNotificationType";

const NotificationType = ({
  fetchNotificationTypes,
  notificationTypes = [],
  ...props
}) => {
  const init = () => {
    fetchNotificationTypes();
  };
  let empId = sessionStorage.getItem("userEmpId");
  useEffect(() => {
    init();
  }, []);
  const data = [];

  const [notifyTypes, setNotifyTypes] = useState(data);

  const createType = (newItem) => {
    setNotifyTypes([...notifyTypes, newItem]);
  };

  const [deleteId, setDeleteId] = useState(null);

  const removeType = (id) => {
    setDeleteId(id);
  };

  const [editmode, setEditMode] = useState(false);
  const [filterTypeIndex, setFilterTypeIndex] = useState("");
  const [filterType, setFilterType] = useState({});
  const editType = (id) => {
    setEditMode(true);
    setFilterTypeIndex(
      notificationTypes?.findIndex((type, index) => type.id === id)
    );
    setFilterType(notificationTypes?.find((type, index) => type.id === id));
  };
  const [showAll, setShowAll] = useState(false);
  const [inactiveItem, setInactiveItem] = useState(null);
  const [activeStatus, setActiveStatus] = useState("Active");
  const [notifyId, setNotifyId] = useState(false);
  const [statusSuccess, setStatusSuccess] = useState(false);
  const inActiveTest = (item, status, id) => {
    setInactiveItem(item);
    setActiveStatus(status);
    setNotifyId(id);
  };

  return (
    <>
      <AddNotificationType
        createType={createType}
        notificationTypes={notificationTypes}
        setNotificationTypes={setNotifyTypes}
        editmode={editmode}
        setEditMode={setEditMode}
        filterTypeIndex={filterTypeIndex}
        filterType={filterType}
        setFilterType={setFilterType}
        activeStatus={activeStatus}
      />
      <DeleteNotificationType
        deleteId={deleteId}
        setNotificationTypes={setNotifyTypes}
        notificationTypes={notificationTypes}
      />
      <ActivateNotificationType
        modalId={"activateModalToggle12"}
        modalLabel={"activateToggleLabel12"}
        inactiveItem={inactiveItem}
        activeStatus={activeStatus}
        setStatusSuccess={setStatusSuccess}
        notifyId={notifyId}
      />
      <div
        className="tab-pane fade show active"
        id="nav-home"
        role="tabpanel"
        aria-labelledby="nav-home-tab"
      >
        <div>
          <div className="setting-header">
            <p className="app-heding">Notification Type</p>
            <div className="applist-right-headbar notifyMobileBtn">
              <div className="d-flex">
                <p className="text-w">Hide Inactive</p>
                <div className="togl-btn">
                  <label className="switch me-3 ms-3">
                    <input
                      type="checkbox"
                      checked={showAll}
                      onChange={() => setShowAll(!showAll)}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
              {empId && empId !== "" && empId !== undefined ? (
                <></>
              ) : (
                <button
                  className="btn btn-genmeb  min-w72"
                  data-bs-toggle="modal"
                  data-bs-target="#notificationType"
                >
                  <img src={Circle} alt="icon" className="me-2" /> Add
                  Notification Type
                </button>
              )}
            </div>
          </div>

          <div className="table-responsive notificationTable ">
            <table className="table table-hover">
              <thead className="table-head">
                <tr>
                  <th>
                    #
                    {/* <span className="ms-2">
                      <img src={sortIcon} alt="icon" />
                    </span> */}
                  </th>
                  <th>
                    Notification Type
                    {/* <span className="ms-2">
                      <img src={sortIcon} alt="icon" />
                    </span> */}
                  </th>
                  {/* <th>Display Name</th> */}
                  <th>Background Color</th>
                  <th>Status</th>
                  <th>
                    Date Added
                    {/* <span className="ms-2">
                      <img src={sortIcon} alt="icon" />
                    </span> */}
                  </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {notificationTypes && notificationTypes?.length === 0 ? (
                  <tr>
                    <td colSpan="6">No Notification Types Available</td>
                  </tr>
                ) : (
                  notificationTypes
                    ?.filter((i) => (!showAll ? i : i.status === true))
                    ?.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.value}</td>
                        {/* <td>{item.value}</td> */}
                        <td className="center-align">
                          <span
                            className="dot-show"
                            style={{
                              backgroundColor:
                                item.colour !== null && item.colour !== ""
                                  ? item.colour
                                  : "#06a894",
                            }}
                          ></span>
                          <span className="spacer-l">
                            {item.colour !== null && item.colour !== ""
                              ? item.colour
                              : "#06a894"}
                          </span>
                        </td>
                        <td>
                          <div className="togl-btn">
                            <span
                              className={`w33 ${
                                item.status === true ? "green" : "red"
                              }`}
                            >
                              {item.status ? "Active" : "Inactive"}
                            </span>
                            <label
                              className="switch me-3 ms-3"
                              data-bs-toggle="modal"
                              data-bs-target="#activateModalToggle12"
                            >
                              {empId && empId !== "" && empId !== undefined ? (
                                <></>
                              ) : (
                                <>
                                  <input
                                    type="checkbox"
                                    checked={
                                      item.status === true ? true : false
                                    }
                                    onChange={() => {
                                      console.log("");
                                    }}
                                    onClick={() => {
                                      inActiveTest(item, item.status, item.id);
                                    }}
                                  />

                                  <span className="slider round"></span>
                                </>
                              )}
                            </label>
                          </div>
                        </td>
                        <td>
                          {moment(item.createdAt).local().format("MM/DD/YYYY")}
                        </td>

                        <td>
                          {empId && empId !== "" && empId !== undefined ? (
                            <></>
                          ) : (
                            <span className="d-flex">
                              {item.status === true && (
                                <img
                                  src={edit}
                                  alt="icon"
                                  className="me-3"
                                  data-bs-toggle="modal"
                                  data-bs-target="#notificationType"
                                  onClick={() => {
                                    editType(item.id);
                                  }}
                                />
                              )}
                              <img
                                src={deleteIcon}
                                alt="icon"
                                onClick={() => removeType(item.id)}
                                data-bs-target="#deleteTypesModal"
                                data-bs-toggle="modal"
                              />
                            </span>
                          )}
                        </td>
                      </tr>
                    ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ master }) => ({
  notificationTypes: master.notificationTypes,
});

const mapDispatchToProps = (dispatch) => ({
  fetchNotificationTypes: () => dispatch(actions.fetchNotificationTypes()),
  createNotificationType: (payload) =>
    dispatch(createNotificationType(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationType);
